import { useEffect, useRef } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { getCleanPath } from 'js/utils/url.util';
import { useAppSelector, useSportsbookSelector } from 'js/store/hooks';

export const useNavigateSportsbook = () => {
    const location = useLocation();
    const isFirstRun = useRef(true);
    const sportsbookRootURL = useAppSelector(prop('sportsbookRootURL'));
    const isAppInitialized = useSportsbookSelector(prop('isAppInitialized'));
    const sportPageRegExp = new RegExp(`(^${sportsbookRootURL}$)|(^${sportsbookRootURL}/)`);
    const isSportPage = sportPageRegExp.test(getCleanPath(location.pathname));

    useEffect(() => {
        if (isAppInitialized && isSportPage) {
            const sportsPathname = getCleanPath(isFirstRun ? window.location.pathname : location.pathname)
                .replace(sportsbookRootURL, '')
                .replace('//', '/') || '/';

            try {
                if (isFirstRun.current && sportsPathname === '/') {
                    isFirstRun.current = false;

                    return;
                }

                window.Sportsbook.navigate(sportsPathname);
                isFirstRun.current = false;
            } catch (error) {
                log('log', '[SPORTSBOOK | Portal] Sportsbook navigate error', error);
            }
        }
    }, [isAppInitialized, isSportPage, sportsbookRootURL, location]);
};
